import { useEffect, useRef, useState } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import style from "./result.module.css";
import {
  generateProgressAtom,
  meshProfileAtom,
  stopChatAtom,
  taskDetailAtom,
  modelSelectedAtom,
  modelHideAtom,
  taskidAtom,
  generatestateAtom,
  currentCardsAtom,
  generateurlsAtom,
  isUploadingAtom,
  imgfileAtom,
  generatedAtom,
  generatingAtom
} from "./store";
import { getTaskDownload,ImaginefacePreview } from "../../net";
import {
  global_render_target_injector,
  load_profile,
} from "../../render/sssss_rendering";
import { exportToImage } from "./utils";
import Loading from '../../assets/loading.svg'

// import { async } from 'q'

function DetailBoard() {
  const setStopChat = useSetRecoilState(stopChatAtom);
  const [taskDetail, ] = useRecoilState(taskDetailAtom);
	const taskid = useRecoilValue(taskidAtom)
	const generatestate = useRecoilValue(generatestateAtom)
  const [generateurls,setGenerateurls]=useRecoilState(generateurlsAtom)
  const [, setIsUploading] = useRecoilState(isUploadingAtom);
  const [meshProfile, setMeshProfile] = useRecoilState(meshProfileAtom);
  const [imgfile, setImgfile] = useRecoilState(imgfileAtom)
  const [showProgress, setShowProgress] = useState(false);
  const [generateProgress, setGenerateProgress] =useRecoilState(generateProgressAtom);
  const [generating,]=useRecoilState(generatingAtom)
  const [, setModelSelected] = useRecoilState(modelSelectedAtom);
  const [, setEnteredMeshProfile] = useState(false);
  const [,setGenerated]=useRecoilState(generatedAtom)
  const [modelHide, setModelHide] = useRecoilState(modelHideAtom);
  const currentCards=useRecoilValue(currentCardsAtom)
  const [cursorPos, setCursorPos] = useState({ x: 160, y: 130 });
  const [grabbing, setGrabbing] = useState(false);
  const clipPathValueA = `inset(0px calc(100%-${cursorPos.x}px) 0px 0px)`;
  const clipPathValueB = `inset(0px 0px calc(100% - ${cursorPos.y}px) ${cursorPos.x}px)`;
  const modelRef = useRef(null);
  const promptRef = useRef(null);
  // const
  useEffect(() => {
    return () => {
      setStopChat(false);
      setMeshProfile(false);
    };
  }, []);
  useEffect(() => {
    if(currentCards==='ImagineFace' && generateProgress){
      if(generatestate){
        setShowProgress(true);
        const counter=setInterval(async ()=>{
          const urls=await ImaginefacePreview(taskid)
          if(urls.data.files[0].face!=='FILE_NOT_FOUND' && urls.data.files[0].render!=='FILE_NOT_FOUND' && urls.data.files[0].render_statue!=='FILE_NOT_FOUND'){
            setGenerateProgress({})
            setGenerateurls([urls.data.files[0].face,urls.data.files[0].render,urls.data.files[0].render_statue])
            setIsUploading(false)
            setGenerated(false)
            setImgfile(false)
            clearInterval(counter);
          }
        },1000)
      }
    } 
  }, [generatestate]);


  useEffect(() => {
    if (!taskDetail) {
      setShowProgress(true);
    }
  }, [taskDetail]);

  

  useEffect(() => {
    const handleMouseDown = () => {
      window.isDraggingModel = true;
    };

    const handleMouseUp = () => {
      window.isDraggingModel = false;
    };

    const modelElement = modelRef.current;
    if (modelElement) {
      modelElement.addEventListener("mousedown", handleMouseDown);
      modelElement.addEventListener("mouseup", handleMouseUp);
    }

    return () => {
      if (modelElement) {
        modelElement.removeEventListener("mousedown", handleMouseDown);
        modelElement.removeEventListener("mouseup", handleMouseUp);
      }
    };
  }, [modelRef]);

  useEffect(() => {
    const updateBodyClass = () => {
      if (window.isDraggingModel) {
        setModelSelected(true);
      } else {
        setModelSelected(false);
      }
    };

    window.addEventListener("mousedown", updateBodyClass);
    window.addEventListener("mouseup", updateBodyClass);

    return () => {
      window.removeEventListener("mousedown", updateBodyClass);
      window.removeEventListener("mouseup", updateBodyClass);
    };
  }, []);

  useEffect(() => {
    if (
      window.static_project &&
      window.last_uuidtime === meshProfile.task_uuid + meshProfile.time
    ) {
      console.log("same profile");
      window.static_project.show_scene();
      if (modelHide) {
        console.log(modelHide);
        return;
      }
      document
        .querySelector("#webglcontainer")
        .replaceWith(window.static_project.content.container);
      return;
    }
    if (window.static_project) {
      console.log("hide scene");
      window.static_project.hide_scene();
      setModelHide(true);
    }
    if (!meshProfile) {
      console.log("no profile");
      return;
    }
    setModelHide(false);
    console.log("Enter meshProfile");
    if (window.static_project) {
      document
        .querySelector("#webglcontainer")
        .replaceWith(window.static_project.content.container);
    }
    setEnteredMeshProfile(true);

    const urlPromise = {
      model: getTaskDownload({
        type: "PreviewPack",
        task_uuid: meshProfile.task_uuid,
        name: "model",
      }),
      diffuse: getTaskDownload({
        type: "PreviewPack",
        task_uuid: meshProfile.task_uuid,
        name: "texture_diffuse",
      }),
      normal: getTaskDownload({
        type: "PreviewPack",
        task_uuid: meshProfile.task_uuid,
        name: "texture_normal",
      }),
      spectular: getTaskDownload({
        type: "PreviewPack",
        task_uuid: meshProfile.task_uuid,
        name: "texture_specular",
      }),
    };
    (async (urlP) => ({
      model: await urlP["model"],
      diffuse: await urlP["diffuse"],
      normal: await urlP["normal"],
      roughness: await urlP["spectular"],
    }))(urlPromise).then((urls) => {
      setTimeout(() => {
        setShowProgress(false);
        setGenerateProgress(false);
        global_render_target_injector.enabled = false;
  
        load_profile(urls, () => {
          console.log("load_profile done");
          window.last_uuidtime = meshProfile.task_uuid + meshProfile.time;
          if (window.static_project) window.static_project.show_scene();
        });
      }, 1000)
    });
  }, [meshProfile]);


  // 阻止MacOS使用触摸板缩放
  // useEffect(() => {
  // 	const container = modelRef.current
  // 	const onWheel = (event) => {
  // 		event.preventDefault()
  // 		const deltaY = event.deltaY
  // 		const rect = container.getBoundingClientRect()
  // 		const scale = 1 - deltaY * 0.001
  // 		const dx = (event.clientX - rect.left) * (1 - scale)
  // 		const dy = (event.clientY - rect.top) * (1 - scale)
  // 		container.style.transformOrigin = `${dx}px ${dy}px 0px`
  // 		container.style.transform = `scale3d(${scale}, ${scale}, ${scale})`
  // 	}
  // 	container.addEventListener('wheel', onWheel, { passive: false })
  // 	return () => container.removeEventListener('wheel', onWheel)
  // }, [])


  
  const dragSize=(ev)=>{
    if (ev.button !== 0) return;
        setGrabbing(true);
        const startX = ev.clientX;
        const startY = ev.clientY;
        const InitialX = cursorPos.x;
        const InitialY = cursorPos.y;
        const maxX = modelRef.current.clientWidth;
        const maxY = modelRef.current.clientHeight;
        document.onmousemove = function (e) {
            const endX = e.clientX;
            const endY = e.clientY;
            const diffX = endX - startX + InitialX;
            const diffY = endY - startY + InitialY;
            let newX = diffX;
            let newY = diffY;
            if (diffX < 0) {
                newX = 0;
            } else if (diffX > maxX) {
                newX = maxX;
            }
            if (diffY < 0) {
                newY = 0;
            } else if (diffY > maxY) {
                newY = maxY;
            }
            setCursorPos({ x: newX, y: newY });
        };
        document.onmouseup = function () {
            setGrabbing(false);
            document.onmousemove = null;
            document.onmouseup = null;
        };
        if (ev.preventDefault) {
            ev.preventDefault();
        }

  }

  window.exportModelView = async () => {
    await exportToImage(modelRef.current, "model");
  };

  window.exportPrompt = async () => {
    await exportToImage(promptRef.current, "prompt");
  };

  const moveRef=useRef(null)
  const clickMove=()=>{
    if(moveRef.current){
      moveRef.current.click()
    }
  }

  const moveImgRef=useRef(null)
  const clickMoveImg=()=>{
    if(moveImgRef.current){
      moveImgRef.current.click()
    }
  }


  return (
    <div className={style.colDetail} >
      <div className={style.colContent} >
        {currentCards==='DreamFace' && taskDetail && !generating && <div onPointerDown={clickMove} className={style.modelmove}>Explore and Export at Hyperhuman</div>}
        {taskDetail && <a ref={moveRef} href={`https://hyperhuman.deemos.com/chatavatar/${taskDetail.task_uuid}`} target='_blank'/>}
        {currentCards==='ImagineFace' && taskid && !imgfile && !generating && <div onPointerDown={clickMoveImg} className={style.modelmove}>Explore and Export at Hyperhuman</div>}
        {taskid && <a ref={moveImgRef} href={`https://hyperhuman.deemos.com/chatavatar/${taskid}`} target='_blank'/>}
        <div
          className={`${style.modelView} ${modelHide && currentCards==='DreamFace' ? style.hideModel : ""}`}
          id="webglcontainer"
          ref={modelRef}
        >
        {currentCards==='ImagineFace' && showProgress && generateProgress && generateProgress.stage &&
        <div
          style={{display:'flex',justifyContent:"right",paddingRight:'10px' }}
          
        >Generating: {generateProgress.percent}/100  </div>}
        
        {currentCards==='ImagineFace' && modelRef.current && generateurls && generateurls.length===3 &&
          <div  
          style={{position:'relative',height:"100%",width:"100%",transition:'none'}} 
          onMouseDown={dragSize}
          >
          
          {generateurls.map((item, index) => (
                <div
                        key={`preview${index}`}
                        className={style.imgBox}
                        style={{
                            
                            clipPath: `${index === 0
                                ? `var(--clip-path-value, ${clipPathValueA})`
                                : index === 1
                                    ? `var(--clip-path-value, ${clipPathValueB})`
                                    : `inset(${cursorPos.y}px 0px 0px ${cursorPos.x}px)`
                                }`,
                        }}
                    >
                    <img src={item} alt="" />
                </div>
                ))}
                <div
                    style={{
                        position: 'absolute',
                        top: `${cursorPos.y}px`,
                        left: `${cursorPos.x}px`,
                        width: '100%',
                        height: '1px',
                        backgroundColor: 'white',
                        transition:'none'
                    }}
                />
                <div
                    style={{
                        position: 'absolute',
                        top: '0',
                        width: '1px',
                        height: '100%',
                        backgroundColor: 'white',
                        left: `${cursorPos.x}px`,
                        transition:'none'
                    }}
                />
                <div
                    style={{
                        top: `${cursorPos.y}px`,
                        left: `${cursorPos.x}px`,
                        cursor:grabbing?'':'pointer'
                    }}
                    className={style.FrameBox}

                >
                    <span />
                    <span />
                    <span />
                </div>
          </div>
        }
        </div>

        {currentCards==='DreamFace' && <div
          style={{ position: "absolute", zIndex: -100 }}
          className={style.loadingCon}
        >
          <div id="info"></div>
          <div id="preloader" className="preloader">
            <div id="preloaderBar" className="vAligned">
              Loading...
              <div className="preloaderBorder">
                <div
                  id="preloaderProgress"
                  className="preloaderProgress"
                  style={{ width: "85%" }}
                ></div>
              </div>
            </div>
          </div>
        </div>}
        <div className={style.modelInfoCon}>
          {showProgress && generateProgress &&
            generateProgress.stage && 

                <div className={style.progressCon} style={{top:currentCards==='ImagineFace'?'calc(70%)':""}}>
                  <img src={Loading}/>
                  <div className={style.progressInfo}>
                    {currentCards==='DreamFace'?generateProgress.stage + "...":'Loading...'}
                  </div>
                  <div className={style.progressTrack}>
                    <div
                      className={style.progressThumb}
                      style={{ width: `${generateProgress.percent}%` }}
                    ></div>
                  </div>
                </div>}
        </div>
      </div>
    </div>
  );
}

export { DetailBoard };
